export default __webpack_public_path__ + "static/media/reservations.0804a910.svg";